import type {Result, UseCase} from 'framework';
import type {FocusModePreference} from '../../domain/focus-mode-preference.value-object';
import type {FocusModePreferenceRepository} from '../ports/focus-mode-preference.repository';

export class SetFocusModePreference implements UseCase<[FocusModePreference], void> {
  constructor(private readonly repository: FocusModePreferenceRepository) {}

  execute(preference: FocusModePreference): Promise<Result<void>> {
    return this.repository.set(preference);
  }
}
